module.exports = __webpack_public_path__ + "img/6_Schön wie du bist MRS Freilassing.b03c52d4.jpg";